import { ShopifyPlan } from "@redotech/redo-model/integration/shopify/shopify-plan";
import * as z from "zod/v4";

export const getShopifyPlan = {
  name: "getShopifyPlan" as const,
  input: z.null(),
  output: z.object({
    plan: z.enum([ShopifyPlan.NONE, ShopifyPlan.STANDARD, ShopifyPlan.PLUS]),
  }),
};
